import { get, post } from './client';

export const listNotifications = (params = {}) => get('/app-notifications', params);

export const getUnreadCount = () => get('/app-notifications/unread-count');

export const markRead = (notificationId) => post(`/app-notifications/${notificationId}/read`);

export const markAllRead = () => post('/app-notifications/read-all');
